// extracted by mini-css-extract-plugin
export default {"InputContainer":"PremierPartnerGroupSingleSelect_InputContainer__yCDSJ"};